import { useMemo, useState } from "react";

import { useHarmonicIntervalFn } from "react-use";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

const TimeDuration = () => {
  const started = useMemo(() => dayjs().valueOf(), []);

  const [time, setTime] = useState(() =>
    dayjs.duration(dayjs(dayjs()).diff(dayjs(started))).format("mm:ss"),
  );

  useHarmonicIntervalFn(() => {
    setTime(
      dayjs.duration(dayjs(dayjs()).diff(dayjs(started))).format("mm:ss"),
    );
  }, 1000);

  return <>{time}</>;
};

export default TimeDuration;
